import styled from "styled-components";

import { setFontVariant } from "@similarweb/styles";
import { RadioButton, RadioLabelText } from "@similarweb/ui-components";

export const StyledRadioSelection = styled.div`
    align-items: center;
    display: flex;
    column-gap: 32px;
`;

export const StyledRadioContainer = styled.div`
    align-items: center;
    display: flex;
`;

export const StyledRadioButton = styled(RadioButton)`
    padding: 0;

    ${RadioLabelText} {
        ${({ buttonSize }) => setFontVariant(buttonSize === "sm" ? "report" : "body1")};
    }
`;
